import * as React from "react";
const SvgFiRrTachometerAltFastest = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 4.052a12 12 0 0 0-16.388 17.52A5 5 0 0 0 7.12 23h9.767a4.84 4.84 0 0 0 3.354-1.288A12.053 12.053 0 0 0 20 4.052M18.868 20.26c-.542.491-1.25.756-1.981.741H7.12a3 3 0 0 1-2.11-.858 10 10 0 1 1 13.858.117m.2-7.269a1 1 0 0 1-1.132-.848A6.02 6.02 0 0 0 12 7c-5.268-.1-8.04 6.686-4.193 10.285a1 1 0 0 1-1.4 1.43C1.287 13.848 4.939 4.915 12 5a8.035 8.035 0 0 1 7.919 6.858 1 1 0 0 1-.85 1.132zm.3 3.244a1 1 0 0 1-1.318.514l-4.867-2.136a2 2 0 1 1 .8-1.832l4.867 2.136a1 1 0 0 1 .518 1.318"
    />
  </svg>
);
export default SvgFiRrTachometerAltFastest;
